<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <!--begin: Search -->
    <!-- <b-dropdown
      size="sm"
      id="kt_quick_search_toggle"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div class="btn btn-icon btn-clean btn-lg btn-dropdown mr-1">
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <inline-svg src="media/svg/icons/General/Search.svg" />
          </span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <KTSearchDefault></KTSearchDefault>
      </b-dropdown-text>
    </b-dropdown> -->
    <!--end: Search -->

    <!--begin: User Bar -->

    <div
      v-if="
        currentUser !== null &&
        currentUser.email &&
        this.$router.currentRoute.name === 'home'
      "
      class="btn btn-primary btn-rounded px-7 py-3 ml-4 text-uppercase"
      @click="$router.push('/dashboard')"
    >
      <h6 class="m-0 p-0">Dashboard</h6>
    </div>
    <KTQuickUser
      class="ml-4"
      v-if="currentUser !== null && currentUser.email"
    ></KTQuickUser>
    <div
      v-else
      class="btn btn-primary btn-rounded px-7 py-3 ml-4 text-uppercase"
      @click="$router.push('/login')"
    >
      <h6 class="m-0 p-0">Login</h6>
    </div>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import KTSearchDefault from "@/view/layout/extras/dropdown/SearchDefault.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages,
    };
  },
  created() {
    console.log();
  },
  components: {
    KTSearchDefault,
    KTQuickUser,
    // KTQuickPanel,
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
  },
};
</script>
